<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="33"
		height="32"
		viewBox="0 0 33 32"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2.16602 16.0001C2.16602 8.084 8.58326 1.66675 16.4993 1.66675C24.4154 1.66675 30.8327 8.08399 30.8327 16.0001C30.8327 23.9161 24.4154 30.3334 16.4993 30.3334C8.58326 30.3334 2.16602 23.9161 2.16602 16.0001ZM16.4993 3.66675C9.68783 3.66675 4.16602 9.18857 4.16602 16.0001C4.16602 22.8115 9.68784 28.3334 16.4993 28.3334C23.3108 28.3334 28.8327 22.8115 28.8327 16.0001C28.8327 9.18857 23.3108 3.66675 16.4993 3.66675ZM16.4993 7.00008C17.0516 7.00008 17.4993 7.4478 17.4993 8.00008V15.0001H24.4993C25.0516 15.0001 25.4993 15.4478 25.4993 16.0001C25.4993 16.5524 25.0516 17.0001 24.4993 17.0001H16.4993C15.9471 17.0001 15.4993 16.5524 15.4993 16.0001V8.00008C15.4993 7.4478 15.9471 7.00008 16.4993 7.00008Z"
			fill="#000"
		/>
	</svg>
</template>
